import { useIntl } from '@capsicum/common';

export const useWCPledgeTokensTabTexts = () => {
	const { $t } = useIntl();

	return {
		buttonText: $t('worldChampionshipPledge.tokenTab.buttonText'),
		filtersTexts: {
			africa: $t('worldChampionshipPledge.tokenTab.filters.africa'),
			all: $t('worldChampionshipPledge.tokenTab.filters.all'),
			asia: $t('worldChampionshipPledge.tokenTab.filters.asia'),
			europe: $t('worldChampionshipPledge.tokenTab.filters.europe'),
			northAmerica: $t('worldChampionshipPledge.tokenTab.filters.northAmerica'),
			oceania: $t('worldChampionshipPledge.tokenTab.filters.oceania'),
			showAvailableOnly: $t('worldChampionshipPledge.tokenTab.filters.showAvailableOnly'),
			southAmerica: $t('worldChampionshipPledge.tokenTab.filters.southAmerica'),
			top10: $t('worldChampionshipPledge.tokenTab.filters.top10')
		},
		searchPlaceholder: $t('worldChampionshipPledge.tokenTab.searchPlaceholder'),
		selectAllCheckboxLabel: $t('worldChampionshipPledge.tokenTab.selectAllCheckboxLabel'),
		teamSelectedSummary: $t('worldChampionshipPledge.tokenTab.teamSelectedSummary'),
		title: $t('worldChampionshipPledge.tokenTab.title')
	};
};
